import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import messages from '../../../locale/messages';
import CreateListingForm from './CreateListingForm';

import s from '../CreateReservationModal/CreateReservationModal.css';

class CreateListingModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
  };

  render() {
    const { show, onClose } = this.props;

    return (
      <div>
        <Modal
          show={show}
          onHide={onClose}
          className={'adminModal'}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage {...messages.createListingForHost} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CreateListingForm onStarted={onClose} />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(CreateListingModal));
